import { useAtomCallback } from 'jotai/utils';
import { atom } from 'jotai';
import { useCallback } from 'react';

export type RubricConfigActions = 'create' | 'edit' | 'delete';
export const selectedRubricConfigActionAtom = atom<RubricConfigActions | null>(null);

export const selectedRubricConfigIdAtom = atom<number | null>(null);

export function useResetRubricConfigFormState() {
  return useAtomCallback(
    useCallback((get, set) => {
      set(selectedRubricConfigActionAtom, null);
      set(selectedRubricConfigIdAtom, null);
    }, [])
  );
}
